import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TransportistaNotificacionesGatewayApi } from 'src/core/apis/notificaciones.list';
import { toNotificacionesList } from 'src/app/services/pedidos/gateway-consultas.mapper';

export interface Notificacion {
  fecha: string;
  titulo: string;
  folio_h: string;
  tkt_h: string;
  orden: number;
  fecha_orden: string;
}

export interface NotificacionGroup {
  fecha: string;
  items: Notificacion[];
}

@Injectable({
  providedIn: 'root',
})
export class NotificacionService {
  constructor(
    private readonly notificacionesGateway: TransportistaNotificacionesGatewayApi
  ) {}

  /**
   * @param background Precarga silenciosa (shell): no dispara logout ante 401.
   */
  getNotificaciones(background = false): Observable<Notificacion[]> {
    const options = background
      ? { headers: this.gatewayBackgroundHeaders() }
      : undefined;
    return this.notificacionesGateway
      .post(options)
      .pipe(map((raw) => toNotificacionesList(raw) as Notificacion[]));
  }

  getNotificacionesAgrupadas(): Observable<NotificacionGroup[]> {
    return this.getNotificaciones().pipe(
      map((data) => this.groupNotifications(data))
    );
  }

  private gatewayBackgroundHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('X-Skip-Loader', '1')
      .set('X-Background-Request', '1');
  }

  private groupNotifications(list: Notificacion[]): NotificacionGroup[] {
    const mapFecha = new Map<string, Notificacion[]>();

    list.forEach((item) => {
      const fecha = item.fecha_orden || item.fecha;

      if (!mapFecha.has(fecha)) {
        mapFecha.set(fecha, []);
      }
      mapFecha.get(fecha)!.push(item);
    });

    for (const [, arr] of mapFecha) {
      arr.sort((a, b) => {
        if (a.folio_h !== b.folio_h) {
          return a.folio_h.localeCompare(b.folio_h);
        }
        return a.orden - b.orden;
      });
    }

    return Array.from(mapFecha.entries())
      .sort((a, b) => new Date(b[0]).getTime() - new Date(a[0]).getTime())
      .map(([fecha, items]) => ({ fecha, items }));
  }
}
